import { graphql, useFragment } from 'react-relay';

import type { PaymentActiveInstallmentExpired_charge$key } from './__generated__/PaymentActiveInstallmentExpired_charge.graphql.ts';
import PaymentExpired from '../../expired/PaymentExpired.tsx';

import type { ReactNode } from 'react';

type PaymentActiveInstallmentExpired = {
  charge: PaymentActiveInstallmentExpired_charge$key;
};

const PaymentActiveInstallmentExpired = (
  props: PaymentActiveInstallmentExpired,
): ReactNode => {
  const charge = useFragment<PaymentActiveInstallmentExpired_charge$key>(
    graphql`
      fragment PaymentActiveInstallmentExpired_charge on Charge {
        ...PaymentExpired_charge
      }
    `,
    props.charge,
  );

  return <PaymentExpired charge={charge} />;
};

export default PaymentActiveInstallmentExpired;
